export default __webpack_public_path__ + "static/media/Block2.0d4939a7.svg";